module.exports = __webpack_public_path__ + "img/DeepeningCategoryScreenshot-1250h.436706ca.webp";